<template>
    <div>
        <Header :data_status="data_status"></Header>
        <div>
            <div class="card-block" v-show="data_status != 'loading'">
                <div class="inline" justify="between" valign="center">
                    <h1>Верификация #{{ $route.params.id }}<router-link class="button _free _second" to="/authorization">К списку</router-link></h1>
                    <div class="inline" :status="request_status">
                        <div class="button _free _second" @click="showPopup({popup: 'rollback', text: data.parking.id})" v-if="data.parking && data.parking.rollback_possible">Откат</div>
                        <div v-if="data.approved" class="text-accept">Подтверждено</div>
                        <div v-if="data.rejected"  class="text-decline">Отказано</div>

                        <div v-if="!data.approved" class="button _free _accept" @click="approve()">Принять</div>
                        <div v-if="!data.rejected" class="button _free _decline" @click="reject()">Отклонить</div>
                    </div>
                </div>
                <form class="card">
                    <div class="inline">
                        <div class="grid">
                            <h3>Пользователь:</h3>
                            <div class="text-item" v-if="data.user">
                                <span>Email</span>
                                <p><router-link :to="'/users/' + data.user.id">{{ data.user.email }}</router-link></p>
                            </div>
                            <div class="text-item">
                                <span>Статус</span>
                                <p>{{ data.role }}</p>
                            </div>
                            <div class="form-item" v-if="data.user">
                                <label for="userphone">Телефон</label>
                                <input type="text" id="userphone" class="text-input" v-model="data.user.phone" />
                            </div>
                            <div class="form-item" v-if="data.user">
                                <label for="userdni">DNI</label>
                                <input type="text" id="userdni" class="text-input" v-model="data.user.dni" />
                            </div>
                        </div>
                        <div class="grid">
                            <h3>Запрос:</h3>
                            <div class="text-item" v-if="data.parking">
                                <span>Парковка</span>
                                <p><router-link :to="'/parking/' + data.parking.id">{{ data.parking.address }}</router-link></p>
                            </div>
                            <div class="text-item" v-if="data.ctime">
                                <span>Дата создания запроса</span>
                                <p>{{ data.ctime }}</p>
                            </div>
                            <div class="text-item" v-if="data.auth_ctime">
                                <span>Дата подачи запроса</span>
                                <p>{{ data.auth_ctime }}</p>
                            </div>

                            <div class="text-item">
                                <span>Статус</span>
                                <p>{{ data.status_text }}</p>
                            </div>

                        </div>
                        <div class="grid">
                            <h3>Доступ к разделам:</h3>
                            <div class="form-item checkbox">
                                <input type="checkbox" id="access1" v-model="data.access_parking" />
                                <label for="access1">Добавление/удаление мест</label>
                            </div>
                            <div class="form-item checkbox">
                                <input type="checkbox" id="access2" v-model="data.access_discount" />
                                <label for="access2">Изменение скидок</label>
                            </div>
                            <div class="form-item checkbox">
                                <input type="checkbox" id="access3" v-model="data.access_booking" />
                                <label for="access3">Просмотр текущего букинга</label>
                            </div>
                            <div class="form-item checkbox">
                                <input type="checkbox" id="access4" v-model="data.access_settings" />
                                <label for="access4">Основные настройки</label>
                            </div>
                        </div>
                    </div>
                    <div class="images" v-if="data.files">
                        <ZoomImage v-for="(item, index) in data.files" :key="index" :src="item"/>
                    </div>
                </form>
                <div class="submit button _free" v-show="showButton" @click="update()">Сохранить</div>
            </div>
            <div class="page-load" v-show="data_status == 'loading'">
                <div class="inline" valign="center">
                    <img src="~@/assets/img/preloader.svg" class="preloader"> Загрузка
                </div>
            </div>
        </div>
        <Rollback v-if="popup.active == 'rollback'" :data.sync="popup" @rollbackSuccess="rollbackSuccess()"></Rollback>

    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import ZoomImage from '@/components/ZoomImage.vue'
    import Rollback from '@/components/Rollback.vue'

    import popups from '@/mixins/popups'

    export default {
        mixins: [popups],
        components: {
            Header,
            ZoomImage,
            Rollback
        },
        data () {
            return {
                data: {},
                data_backup: false,
                data_status: 'init',
                request_status: '',
            }
        },
        computed: {
          showButton () {
              if (JSON.stringify(this.data) == this.data_backup) {
                  return false
              }
            return true
          }
        },
        created () {
            this.getData()
        },
        methods: {
            rollbackSuccess () {
                this.data.parking.rollback_possible = false
                this.savedata()
            },
            savedata () {
                this.data_backup = JSON.stringify(this.data)
            },
            update () {
                let json = JSON.stringify(this.data)
                return new Promise((resolve, reject) => {
                    this.request_status = 'loading'
                    this.axios.post('api/admin/v2/authorization/' + this.$route.params.id, json, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }).then(() => {
                        this.request_status = ''
                        this.savedata()
                        let msg = {
                            message: 'Данные обновлены',
                            status: 'success'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        resolve()
                    }).catch(() => {
                        this.request_status = ''
                        let msg = {
                            message: 'Ошибка при обновлении данных',
                            status: 'error'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        reject()
                    })
                })
            },
            reject () {
                return new Promise((resolve, reject) => {
                    this.request_status = 'loading'
                    this.axios.post('api/admin/v2/authorization/' + this.$route.params.id + '/reject')
                        .then(() => {
                            this.request_status = ''
                            this.data.rejected = true
                            this.data.approved = false
                            this.savedata()
                            resolve()
                        })
                        .catch(() => {
                            this.request_status = ''
                            let msg = {
                                message: 'Ошибка при изменении статуса',
                                status: 'error'
                            }
                            this.$store.dispatch('utils/showMessage', msg)
                            reject()
                        })
                })
            },
            approve () {
                return new Promise((resolve, reject) => {
                    this.request_status = 'loading'
                    this.axios.post('api/admin/v2/authorization/' + this.$route.params.id + '/approve')
                        .then(() => {
                            this.request_status = ''
                            this.data.approved = true
                            this.data.rejected = false
                            this.savedata()
                            resolve()
                        })
                        .catch(() => {
                            this.request_status = ''
                            let msg = {
                                message: 'Ошибка при изменении статуса',
                                status: 'error'
                            }
                            this.$store.dispatch('utils/showMessage', msg)
                            reject()
                        })
                })
            },
            getData () {
                return new Promise((resolve) => {
                    this.data_status = 'loading'
                    this.axios.get('api/admin/v2/authorization/' + this.$route.params.id)
                        .then(resp => {
                            this.data = resp.data.response
                            this.savedata()
                            this.data_status = ''
                            resolve()
                        })
                        .catch(() => {
                            this.$router.push('/authorization')
                        })
                })
            }
        }
    }
</script>
